import { brand } from '../../../theme/themePrimitives';
import ImageClass from '../../../assets';
import { setIsSales } from '../../../redux/slices';
import { useNavigate } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Typography } from '@mui/material';
import { resetStatesExceptAuth, resetStatesExceptAuthAndClient } from '../../../helper/reset_helper';
import { styled, useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';

const CustomSwitchContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(92, 92, 92)' : 'rgb(231, 231, 231)',
    borderRadius: '20px',
    width: '100px',
    height: '35px',
    position: 'relative',
    cursor: 'pointer'
}));

/**
 * @heading4: Styled Swich Thumb
 * @block_quotes: Swich thumb styles has been added
 */
const CustomSwitchThumb = styled(Box)<{ selected: boolean }>(({ selected }) => ({
    position: 'absolute',
    top: '0',
    left: selected ? '20%' : '0',
    transform: selected ? 'translateX(0)' : 'translateX(0)',
    width: '80px',
    height: '100%',
    borderRadius: '20px',
    backgroundColor: selected ? 'rgb(239, 197, 56)' : brand[300],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: 600,
    fontSize: '0.8rem',
    transition: 'left 0.3s ease-in-out'
}));


const SwitchLabel = styled(Typography)(() => ({
    fontSize: '0.9rem',
    fontWeight: 500,
    color: 'transparent'
}));

const LogoSwitchComponent = ({ setSelectedpage }: {setSelectedpage: (value: string) => void}) => {
    const navigate = useNavigate();
    const { isSales, currentUser } = useSelector((state: RootState) => state.app);
    const dispatch = useDispatch<AppDispatch>();
    const theme = useTheme();

    const dashboardMovement = () => {
        if (window.location.pathname.includes('/dashboard')) return;
        if (currentUser?.role === 'client') {
            resetStatesExceptAuthAndClient(dispatch);
            navigate(`/app/client/${currentUser.client_id}/dashboard`);
        } else {
            resetStatesExceptAuth(dispatch);
            setSelectedpage('dashboard');
            navigate('/app/dashboard');
        }
    };

    const handleToggle = async (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        await resetStatesExceptAuth(dispatch);
        dispatch(setIsSales(!isSales));
        dashboardMovement();
    };


    return (<Box display="flex" gap="10px" >
        <Box display="flex" alignItems="center" onClick={dashboardMovement} sx={{
            cursor: 'pointer'
        }}>
            <img src={theme.palette.mode === 'dark' ? ImageClass.logoDark : ImageClass.logoLight} alt="Company logo" height={40} />
        </Box>
        {(currentUser?.role === 'organizationAdmin' || currentUser?.role === 'organizationOwner') && !location.pathname.includes('subscription') && <CustomSwitchContainer onClick={handleToggle}>
            <SwitchLabel style={{ marginLeft: '8px' }}>
                {isSales ? '' : 'Sales'}
            </SwitchLabel>
            <CustomSwitchThumb selected={isSales}>
                {isSales ? 'Fulfillment' : 'Sales'}
            </CustomSwitchThumb>
            <SwitchLabel style={{ marginRight: '8px' }}>
                {isSales ? '' : 'Fulfillment'}
            </SwitchLabel>
        </CustomSwitchContainer>}
    </Box>);
};

export default LogoSwitchComponent;